import { render } from "./DocumentLocatorTestingTable.vue?vue&type=template&id=0c0c7392&scoped=true&ts=true"
import script from "./DocumentLocatorTestingTable.vue?vue&type=script&lang=ts"
export * from "./DocumentLocatorTestingTable.vue?vue&type=script&lang=ts"

import "./DocumentLocatorTestingTable.vue?vue&type=style&index=0&id=0c0c7392&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0c7392"]])

export default __exports__